var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle7, _circle8, _circle9, _circle10;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 123,
    viewBox: "0 0 150 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.1339,
    cy: 70.0446,
    r: 47.0089,
    fill: "#FFE7E7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.0714,
    cy: 38.3034,
    r: 2.94643,
    fill: "#FFE7E7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.4733,
    cy: 17.5445,
    r: 5.49107,
    fill: "#FFE7E7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.491,
    cy: 107.545,
    r: 5.22321,
    fill: "#FFE7E7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.491,
    cy: 95.2232,
    r: 5.22321,
    fill: "#FFE7E7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.313,
    cy: 101.116,
    r: 2.54464,
    fill: "#FFE7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.8192 25.3223C77.6639 25.2893 77.6639 25.0676 77.8192 25.0346L80.1672 24.5353C80.2238 24.5233 80.2681 24.4792 80.2803 24.4226L80.7859 22.0912C80.8194 21.9367 81.0398 21.9367 81.0733 22.0912L81.5789 24.4226C81.5911 24.4792 81.6354 24.5233 81.692 24.5353L84.0399 25.0346C84.1952 25.0676 84.1952 25.2893 84.0399 25.3223L81.692 25.8216C81.6354 25.8336 81.5911 25.8777 81.5789 25.9343L81.0733 28.2657C81.0398 28.4202 80.8194 28.4202 80.7859 28.2657L80.2803 25.9343C80.2681 25.8777 80.2238 25.8336 80.1672 25.8216L77.8192 25.3223Z",
    fill: "#F8AFAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1669 73.2915C24.2268 73.0083 24.631 73.0083 24.691 73.2915L25.5864 77.5216C25.6082 77.6247 25.6884 77.7055 25.7914 77.7279L29.9779 78.6399C30.259 78.7012 30.259 79.1021 29.9779 79.1633L25.7914 80.0754C25.6884 80.0978 25.6082 80.1785 25.5864 80.2816L24.691 84.5118C24.631 84.795 24.2268 84.795 24.1669 84.5118L23.2715 80.2816C23.2497 80.1785 23.1694 80.0978 23.0664 80.0754L18.88 79.1633C18.5988 79.1021 18.5988 78.7012 18.88 78.6399L23.0664 77.7279C23.1694 77.7055 23.2497 77.6247 23.2715 77.5216L24.1669 73.2915Z",
    fill: "#F8AFAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.146 39.5415C117.206 39.2583 117.61 39.2583 117.67 39.5415L118.192 42.0093C118.214 42.1124 118.295 42.1931 118.397 42.2155L120.847 42.7491C121.128 42.8103 121.128 43.2113 120.847 43.2725L118.397 43.8061C118.295 43.8285 118.214 43.9093 118.192 44.0123L117.67 46.4801C117.61 46.7633 117.206 46.7633 117.146 46.4801L116.624 44.0123C116.602 43.9093 116.522 43.8285 116.419 43.8061L113.969 43.2725C113.688 43.2113 113.688 42.8103 113.969 42.7491L116.419 42.2155C116.522 42.1931 116.602 42.1124 116.624 42.0093L117.146 39.5415Z",
    fill: "#F8AFAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.944 79.1062L128.765 82.9814L132.584 83.8135L128.765 84.6457L127.944 88.5209L127.124 84.6457L123.304 83.8135L127.124 82.9814L127.944 79.1062Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.786 48.75L38.4375 72.9911L51.9643 110.625L60.1339 114.241L70.3125 116.384L80.625 115.982L86.6518 114.911L92.0089 113.304L100.848 108.75L108.348 102.857L108.927 102.109C112.196 97.8834 115.094 93.3841 117.589 88.6607L101.786 48.75Z",
    fill: "#FFE7E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2591 62.2768L36.5626 58.5268L94.6876 36.5625L91.6073 44.1964L93.884 51.2946L45.8037 69.6429L43.2591 62.2768Z",
    fill: "#FFD3D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6965 110.491V110.491C57.5577 113.488 63.9032 115.423 70.4392 116.207L70.6024 116.227L75.2624 116.227C78.753 116.227 82.2336 115.855 85.6456 115.119L86.8008 114.869C90.4488 114.082 93.971 112.796 97.2681 111.047V111.047C99.8407 109.683 102.259 108.046 104.482 106.165L105.204 105.555C107.133 103.922 108.923 102.132 110.555 100.203V100.203C112.841 97.502 114.804 94.5439 116.405 91.3884L117.857 88.5266",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9238 72.4324L51.9645 110.75",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.344 48.7271L117.747 88.9747",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5131 58.6376L95.5113 36.0926",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6135 73.1226L101.499 48.4851L92.0814 44.1112C91.811 43.9856 91.6952 43.6634 91.8237 43.3944L95.1036 36.5314",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0514 58.4527L42.8047 62.0735C43.0614 62.2111 43.1611 62.5286 43.0291 62.7883L37.9238 72.8342",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.781 57.968L40.1325 68.8452",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1251 62.6785L45.8037 70.1785",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8751 43.9285L94.5537 51.6963",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1506 36.6567L98.9953 47.2537",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.0804,
    cy: 69.5088,
    r: 2.8125,
    fill: "#FFD3D2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.0626,
    cy: 55.0446,
    r: 2.00893,
    fill: "#FFE7E7"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.759,
    cy: 62.8125,
    r: 2.8125,
    fill: "#FFD3D2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.384,
    cy: 50.4909,
    r: 2.00893,
    fill: "#FFE7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty_cart.bdde627ffec6b5c0aa2f99b0a0f39a74.svg";
export { ForwardRef as ReactComponent };